define([
    "jquery",
    "underscore",
    "marionette",
    "swiper",
    "views/common/callback_view"
], function($, _, Marionette, Swiper, CallbackView) {
    return Marionette.View.extend({
        el: '#footer_layout',

        ui:{
            'ukWarningPopup': '#uk_warning_popup'
        },

        initialize: function(){
            this.bindUIElements();

            if(window.lang == 'ja_JP'){
                new CallbackView();
            }

            if(0 < this.ui.ukWarningPopup.length){
                this.ui.ukWarningPopup.modal();
            }

            new Swiper('.swiper-container', {
                slidesPerView: 7,
                initialSlide: 7,
                noSwiping: true,
                autoplayDisableOnInteraction: false,
                loop: true,
                autoHeight: true,
                autoplay: 1500
            });
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/common/footer_view.js
// module id = 17
// module chunks = 0